import request from '../_util/request';
import { computed, defineComponent, ref, watch } from 'vue';
import DatePicker, { RangePicker } from '../date-picker';
import { commonProps, rangePickerProps, datePickerProps } from '../date-picker/generatePicker/props';
import '../vc-picker/RangePicker';
import { DateFormatMap, DateSpanMap, DateTypeEnum, DateDefaultMap, DateRangeDefaultMap, RangeTypeEnum } from './enums';
import { withInstall } from '../_util/type';
import 'dayjs';
import classNames from '../_util/classNames';
import useConfigInject from '../_util/hooks/useConfigInject';
import { FormItemRest } from '../form';
import { useInjectFormItemContext } from '../form/FormItemContext';
const rangeSinglePickerProps = () => ({
    pickerClassName: String, // 分开选择的区间选择单个选择器样式
});
const _commonProps = commonProps();
const _datePickerProps = datePickerProps();
const _rangePickerProps = rangePickerProps();
const _rangeSinglePickerProps = rangeSinglePickerProps();
function datePickerProProps() {
    return {
        ..._commonProps,
        ..._datePickerProps,
        ..._rangePickerProps,
        ..._rangeSinglePickerProps,
        defaultPickerValue: {
            type: Array
        },
        defaultValue: {
            type: Array
        },
        value: {
            type: Array
        },
        disabledTime: {
            type: [Function, Function]
        },
        format: _datePickerProps.format,
        renderExtraFooter: {
            type: [Function, Function]
        },
        onChange: {
            type: [Function, Function]
        },
        'onUpdate:value': {
            type: [Function, Function]
        },
        onOk: {
            type: [Function, Function]
        },
        code: String,
        hisUuid: String,
        domain: String,
        config: Object,
        onConfigChange: Function,
        'onUpdate:configValue': Function,
    };
}
const getCofig = (params) => request('/develop/module/time/render.open', {
    params
});
const mergeProps = (originProps, props) => {
    let res = {};
    Object.keys(originProps).forEach(key => {
        if (props.hasOwnProperty(key) && props[key] !== undefined) {
            res[key] = props[key];
        }
    });
    return res;
};
const isEmptyRange = (value) => {
    if (!value?.length) {
        return true;
    }
    const [start, end] = value || [];
    return !(start || end);
};
const DatePickerPro = defineComponent({
    name: 'PfDatePickerPro',
    inheritAttrs: false,
    props: datePickerProProps(),
    slots: [
        'suffixIcon',
        'prevIcon',
        'nextIcon',
        'superPrevIcon',
        'superNextIcon',
        'dateRender',
        'renderExtraFooter',
        'monthCellRender',
    ],
    setup(props, { attrs, slots, emit }) {
        const { prefixCls } = useConfigInject('picker', props);
        const formItemContext = useInjectFormItemContext();
        const configLoading = ref(false);
        const config = ref();
        const cacheDates = ref();
        const rangeValue = ref();
        const hackValue = ref();
        const selectDefaultValue = ref();
        const handleConfig = (value) => {
            const formatData = DateFormatMap.findById(value?.formate);
            const _config = {
                ...value,
                picker: formatData?.picker,
                showTime: formatData?.showTime,
                format: formatData?.name
            };
            config.value = _config;
            props.onConfigChange?.(_config);
            emit('update:configValue', _config);
            if (props.value) {
                return;
            }
            if (props.defaultValue) {
                if (value?.type === DateTypeEnum.Select) {
                    selectDefaultValue.value = props.defaultValue;
                }
                else if (value?.type === DateTypeEnum.Span) {
                    rangeValue.value = props.defaultValue;
                }
            }
            else if (value?.defaultVal) {
                if (value?.type === DateTypeEnum.Select) {
                    const defaultData = DateDefaultMap.findById(config.value?.defaultVal);
                    const defaultValue = defaultData && defaultData.getDefaultValue && defaultData.getDefaultValue();
                    selectDefaultValue.value = defaultValue;
                    props.onChange?.(defaultValue, defaultValue?.format(formatData?.name));
                    emit('update:value', defaultValue);
                }
                else if (value?.type === DateTypeEnum.Span) {
                    const defaultData = DateRangeDefaultMap.findById(config.value?.defaultVal);
                    const defaultValue = defaultData && defaultData.getDefaultValue && defaultData.getDefaultValue();
                    const valueString = defaultValue?.map(v => v?.format(formatData?.name));
                    const _defaultValue = isEmptyRange(defaultValue) ? null : defaultValue;
                    rangeValue.value = _defaultValue;
                    props.onChange?.(_defaultValue, valueString);
                    emit('update:value', _defaultValue);
                }
            }
        };
        watch([
            () => props.code,
            () => props.hisUuid,
            () => props.domain,
            () => props.config,
        ], ([curCode, curHisUuid, curDomain, curConfig], [preCode, preHisUuid, preDomain, preConfig]) => {
            if ((curCode && curCode !== preCode) || (curHisUuid && curHisUuid !== preHisUuid) || ((curCode || curHisUuid) && curDomain !== preDomain)) {
                configLoading.value = true;
                getCofig({
                    moduleCode: curCode || '',
                    hisUuid: curHisUuid && !curCode ? curHisUuid : ''
                }).then(res => {
                    handleConfig(res);
                }).finally(() => {
                    configLoading.value = false;
                });
            }
            else if (curConfig && (curConfig !== preConfig)) {
                Promise.resolve().then(() => {
                    handleConfig(curConfig);
                });
            }
        }, {
            immediate: true
        });
        const rangeMergedProps = computed(() => mergeProps({
            ..._commonProps,
            ..._rangePickerProps
        }, props));
        const rangeSingleMergedProps = computed(() => {
            const merged = mergeProps({
                ..._commonProps,
                ..._datePickerProps,
                ..._rangeSinglePickerProps
            }, props);
            return {
                ...merged,
                'onUpdate:value': undefined,
                defaultValue: undefined,
                showToday: props.showToday || false,
                showNow: props.showNow || false
            };
        });
        const rangeSingleMergedPickerClass = computed(() => classNames(`${prefixCls.value}-pro-range-single-picker`, props.pickerClassName));
        watch([
            () => props.value,
            () => rangeMergedProps.value?.defaultValue
        ], ([curValue, curDefaultValue]) => {
            if (config.value?.type === DateTypeEnum.Span) {
                rangeValue.value = curValue || curDefaultValue;
            }
        }, {
            immediate: true
        });
        const dateMergedProps = computed(() => mergeProps({
            ..._commonProps,
            ..._datePickerProps,
        }, props));
        const renderDatePicker = () => (<DatePicker placeholder="请选择" defaultValue={selectDefaultValue.value} {...attrs} {...dateMergedProps.value} picker={config.value?.picker} showTime={config.value?.showTime && { format: config.value.showTime }} format={config.value?.format} v-slots={{ ...slots }}/>);
        const handleRangeDisabledDate = (current) => {
            if (!cacheDates.value || cacheDates.value.length === 0) {
                return false;
            }
            const span = DateSpanMap.findById(config.value?.span)?.span;
            const [start, end] = cacheDates.value;
            const tooLate = start && current.diff(start, 'days') > span;
            const tooEarly = end && end.diff(current, 'days') > span;
            return tooEarly || tooLate;
        };
        const handleRangeOpenChange = (open) => {
            if (open) {
                cacheDates.value = [];
                hackValue.value = [];
            }
            else {
                hackValue.value = undefined;
            }
            rangeMergedProps.value?.onOpenChange?.(open);
        };
        const handleRangeChange = (value, dateString) => {
            rangeValue.value = value;
            rangeMergedProps.value?.onChange?.(value, dateString);
        };
        const handleRangeCalendarChange = (value, formatString, info) => {
            cacheDates.value = value;
            rangeMergedProps.value?.onCalendarChange?.(value, formatString, info);
        };
        const renderRangePicker = () => (<RangePicker {...attrs} {...rangeMergedProps.value} picker={config.value?.picker} showTime={config.value?.showTime && { format: config.value.showTime }} format={config.value?.format} disabledDate={handleRangeDisabledDate} onChange={handleRangeChange} onOpenChange={handleRangeOpenChange} onCalendarChange={handleRangeCalendarChange} value={hackValue.value || props.value || rangeValue.value} v-slots={{ ...slots }}/>);
        const handleRangeSingleStartChange = (value) => {
            const range = [value || undefined, rangeValue.value?.[1]];
            const dateString = range.map(v => v?.format(config.value?.format));
            const _range = isEmptyRange(range) ? null : range;
            rangeValue.value = _range;
            rangeSingleMergedProps.value.onChange?.(_range, dateString);
            emit('update:value', _range);
            formItemContext.onFieldChange();
        };
        const handleRangeSingleEndChange = (value) => {
            const range = [rangeValue.value?.[0], value || undefined];
            const dateString = range.map(v => v?.format(config.value?.format));
            const _range = isEmptyRange(range) ? null : range;
            rangeValue.value = _range;
            rangeSingleMergedProps.value.onChange?.(_range, dateString);
            emit('update:value', _range);
            formItemContext.onFieldChange();
        };
        const handleRangeSingleBlur = () => {
            emit('blur');
            formItemContext.onFieldBlur();
        };
        const handleRangeSingleStartDisabledDate = (current) => {
            const end = rangeValue.value?.[1];
            if (!end || typeof end !== 'object') {
                return false;
            }
            const span = DateSpanMap.findById(config.value?.span)?.span;
            const tooLate = current.isAfter(end);
            const tooEarly = end.diff(current, 'days') > span;
            return tooEarly || tooLate;
        };
        const handleRangeSingleEndDisabledDate = (current) => {
            const start = rangeValue.value?.[0];
            if (!start || typeof start !== 'object') {
                return false;
            }
            const span = DateSpanMap.findById(config.value?.span)?.span;
            const tooLate = current.diff(start, 'days') > span;
            const tooEarly = current.isBefore(start);
            return tooEarly || tooLate;
        };
        const renderRangeSinglePicker = () => (<div {...attrs} class={classNames(`${prefixCls.value}-pro-range-single`, attrs.class)}>
        <FormItemRest>
          <DatePicker placeholder="请选择" {...rangeSingleMergedProps.value} value={rangeValue.value?.[0]} onChange={handleRangeSingleStartChange} onBlur={handleRangeSingleBlur} picker={config.value?.picker} showTime={config.value?.showTime && { format: config.value.showTime }} format={config.value?.format} disabledDate={handleRangeSingleStartDisabledDate} class={rangeSingleMergedPickerClass.value} v-slots={{ ...slots }}/>
        </FormItemRest>
        <div class={`${prefixCls.value}-pro-range-single-divider`}/>
        <FormItemRest>
          <DatePicker placeholder="请选择" {...rangeSingleMergedProps.value} value={rangeValue.value?.[1]} onChange={handleRangeSingleEndChange} onBlur={handleRangeSingleBlur} picker={config.value?.picker} showTime={config.value?.showTime && { format: config.value.showTime }} format={config.value?.format} disabledDate={handleRangeSingleEndDisabledDate} class={rangeSingleMergedPickerClass.value} v-slots={{ ...slots }}/>
        </FormItemRest>
      </div>);
        return () => {
            if (config.value?.type === DateTypeEnum.Select) {
                return renderDatePicker();
            }
            else if (config.value?.type === DateTypeEnum.Span) {
                return config.value?.choice === RangeTypeEnum.Single ? renderRangeSinglePicker() : renderRangePicker();
            }
            else {
                return null;
            }
        };
    }
});
export default withInstall(DatePickerPro);
